import React from 'react'
import { Container, Space } from 'components'
import { css } from 'emotion'
import { MEDIA_QUERY } from 'styles'

const CartView = ({ RewardsElement, SummaryReceiptElement }) => (
  <Container>
    <div className={styles.content}>
      <div className={styles.border}>
        {RewardsElement}
        <Space width="4rem" height="4rem" />
        {SummaryReceiptElement}
      </div>
    </div>
  </Container>
)

const styles = {
  content: css({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    overflowX: 'hidden',
  }),
  border: css({
    display: 'flex',
    alignItems: 'center',
    width: '90%',
    maxWidth: '120rem',
    paddingRight: '4rem',
    borderRadius: '1rem',
    marginBottom: '2rem',
    backgroundColor: 'rgba(0,0,0,.6)',
    lineHeight: 1.5,
    [MEDIA_QUERY.LG]: {
      flexDirection: 'column-reverse',
      padding: '2rem',
    },
  }),
}

export default CartView
